module.exports = __webpack_public_path__ + "media/images/views/dashboard/elite-6b734458694b7e5a1e17f41b018ab637.png";